<script>
import DatePicker from "vue2-datepicker";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {getPositionOverview} from "../../../../api/user";
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";

/**
 * Orders component
 */
export default {
    page: {
        title: "持仓总览",
        meta: [{
            name: "description",
            content: appConfig.description,
        } ]
    },
    components: {
        DatePicker,
        Layout,
        PageHeader,
    },
    props: {
        updating: {
            type: Boolean,
        },
    },
    data() {
        return {
            title: "持仓总览",   
            coinFields: [
              {
                key: "coin",
                label: "币种",
                sortable: true
              },
              {
                key: "value",
                label: "持仓价值",
                sortable: true
              },
              {
                key: "predict_rate",
                label: "预计费率",
                sortable: true
              },
              {
                key: "volume24",
                label: "24h成交额",
                sortable: true
              },
              {
                key: "openinterest",
                // label: "币种",
                sortable: true
              },
              {
                key: "io(%)",
                // label: "币种",
                sortable: true
              },
              {
                key: "basis",
                label: "基差",
                sortable: true
              },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 50,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "value",
            sortDesc: true,
            data_map: {},
            selectedExchange: 'BINANCE_USDT',
            exchangeOptions: [],
            exchangeData: [], // 存储后端返回的exchange数据字典
            detailData: [],
            coin: ""
        };
    },
    computed: {
      rows() {
          return this.exchangeData.length;
      },
        /**
         * Total no. of records
         */
        // rows() {
        //     return this.ordersData.length;
        // },
    },
    mounted() {
        // Set the initial number of items
        this.getData()
        // 监听鼠标移动事件，判断是否悬停在value字段上
    },
    methods: {
        /**
         * Search the table data with search input
         */
        // onFiltered(filteredItems) {
        //     // Trigger pagination to update the number of buttons/pages due to filtering
        //     this.totalRows = filteredItems.length;
        //     this.currentPage = 1;
        // },     
    // 获取选中的exchange的数据
    getData() {
        let promise = getPositionOverview(); return promise.then(res => {
            this.data_map = {}; // 清空之前的数据
            this.exchangeOptions = Object.keys(res)
            this.data_map = res; // 使用axios调用后端接口，获取exchange数据
            this.chooseExchange();
        }).catch(error => {
            console.log(error)
        })
      
    },
    chooseExchange() {
        this.exchangeData = this.data_map[this.selectedExchange]
    },
    RowClickHandler(record, index) {
      console.log(record)
      this.detailData = record.details
      this.coin = record.coin
    },  

    },
};
</script>

<template lang="en">
<Layout>
    <PageHeader :title="title"/>
    <h4 class="card-title mb-4">
      持仓明细{{ coin }}
            </h4>
            <div>
    <b-table :items="detailData"></b-table>
  </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              > 
              
                <div class="row mt-4">
                  <!-- <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div> -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Exchange&nbsp;
                        <b-form-select
                          v-model="selectedExchange"
                          :options="exchangeOptions"
                          @change="chooseExchange"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="exchangeData"
                    :fields="coinFields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @row-clicked="RowClickHandler"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>

              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    

</Layout>
</template>
